<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-button @click='add'>添加</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="taskPackageName" label="名称" align="center"></el-table-column>
        <el-table-column prop="taskPackageName" label="类型名称" align="center"></el-table-column>
        <el-table-column prop="type" label="推广奖励类型" align="center">
          <template slot-scope="scope">
            {{getType(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column prop="buyPromotionCoupons" label="购买所需奖励积分" align="center"></el-table-column>
        <el-table-column prop="presentReplacementCoupons" label="奖励置换券" align="center"></el-table-column>
        <el-table-column prop="presentProportion" label="置换券每日赠送比例百分比" align="center"></el-table-column>
        <el-table-column prop="limitNum" label="质押数量限制" align="center"></el-table-column>
        <el-table-column prop="adNum" label="观看广告数量" align="center"></el-table-column>
        <el-table-column prop="state" label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.state === 1 ? '上线中' : '已下线'}}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="操作时间" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-button size="mini" @click="edit(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="编辑任务包" :visible.sync="show" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="名称" label-width='150px'>
          <el-input type="text" v-model="form.taskPackageName" maxlength="10" autocomplete="off" placeholder="请输入任务包名称">
          </el-input>
        </el-form-item>
        <el-form-item label="奖励类型" label-width='150px'>
          <el-select v-model="form.type" placeholder="请选择奖励类型">
            <el-option label="核心奖励" :value="1"></el-option>
            <el-option label="运营奖励" :value="2"></el-option>
            <el-option label="创业奖励" :value="3"></el-option>
            <el-option label="贡献奖励" :value="4"></el-option>
            <el-option label="普通奖励" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买所需奖励积分" label-width='150px'>
          <el-input type="text" v-model="form.buyPromotionCoupons" maxlength="10" autocomplete="off" placeholder="请输入购买所需奖励积分">
          </el-input>
        </el-form-item>
        <el-form-item label="奖励置换券" label-width='150px'>
          <el-input type="text" v-model="form.presentReplacementCoupons" maxlength="10" autocomplete="off" placeholder="请输入奖励置换券">
          </el-input>
        </el-form-item>
        <el-form-item label="置换券每日赠送比例百分比" label-width='150px'>
          <el-input type="text" v-model="form.presentProportion" maxlength="10" autocomplete="off" placeholder="请输入置换券每日赠送比例百分比">
          </el-input>
        </el-form-item>
        <el-form-item label="质押数量限制" label-width='150px'>
          <el-input type="text" v-model="form.limitNum" maxlength="10" autocomplete="off" placeholder="请输入质押数量限制">
          </el-input>
        </el-form-item>
        <el-form-item label="观看广告数量" label-width='150px'>
          <el-input type="text" v-model="form.adNum" maxlength="10" autocomplete="off" placeholder="请输入观看广告数量">
          </el-input>
        </el-form-item>
        <el-form-item label="状态" label-width='150px'>
          <el-select v-model="form.state" placeholder="请选择奖励类型">
            <el-option label="上线" :value="1"></el-option>
            <el-option label="下线" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width='150px'>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      show: false,
      form: {
        taskPackageName: '',
        type: '',
        buyPromotionCoupons: '',
        presentReplacementCoupons: '',
        presentProportion: '',
        limitNum: '',
        adNum: '',
        state: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getType(type) {
      if (type == 1) {
        return '核心奖励'
      } else if (type == 2) {
        return '运营奖励'
      } else if (type == 3) {
        return '创业奖励'
      } else if (type == 4) {
        return '贡献奖励'
      } else if (type == 5) {
        return '普通奖励'
      }
    },
    //获取数据
    getList() {
      var secah = this.secah
      this.httpGet('/admin/promotionCenter/getTaskConfig', secah, true).then(
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data
          }
        }
      )
    },
    add() {
      this.form = {
        taskPackageName: '',
        type: '',
        buyPromotionCoupons: '',
        presentReplacementCoupons: '',
        presentProportion: '',
        limitNum: '',
        adNum: '',
        state: '',
      }
      this.show = true
    },
    edit(row) {
      this.form = row
      this.show = true
    },
    //确定拒绝通过商家审核
    onSubmit() {
      this.httpPost(
        '/admin/promotionCenter/saveOrUpdateTaskConfig',
        this.form,
        true,
        { 'Content-Type': 'application/json' }
      ).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功')
          this.show = false
          this.getList()
        }
      })
    },
    del(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let params = {
            id: row.id,
            state: 2
          }
          this.httpPost(
            '/admin/promotionCenter/saveOrUpdateTaskConfig',
            params,
            true,
            { 'Content-Type': 'application/json' }
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getList()
            }
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
